import React, { Component } from 'react';
import { Badge } from 'reactstrap';
import { Link } from 'react-router-dom';
import { Loading } from '../common/LoadingComponent';
import { MessageCircle, Search } from '../../icons';
import { currentUser } from '../../redux/helpers/currentUser';

class Messages extends Component {
    handleClick(item) {
        this.props.updateNotification(item.announcement.id, currentUser().id, item.user.id);
    }

    render() {
        const { conversations, isLoading, notifications } = this.props;

        if (isLoading) return <div className="container text-center" style={{ padding: '80px 0' }}><Loading /></div>;

        const getUnread = (userId, announcementId) => {
            if (!Array.isArray(notifications) || !notifications.length) return null;
            const n = notifications.find(x =>
                x.idAnnouncement === announcementId &&
                x.idUser         === currentUser().id &&
                x.idUserSender   === userId
            );
            return n ? n.totalMessages : null;
        };

        if (!Array.isArray(conversations) || !conversations.length) {
            return (
                <div className="list-page">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-12 col-md-6">
                                <div className="empty-state">
                                    <div className="empty-state__icon">
                                        <MessageCircle size={48} strokeWidth={1.2} color="var(--border)" />
                                    </div>
                                    <h3 className="empty-state__title">Pas encore de messages</h3>
                                    <p className="empty-state__text">Trouvez un voyageur ou une demande d'envoi et lancez la conversation.</p>
                                    <Link to="/searchannouncements" className="btn btn-primary"
                                        style={{ borderRadius: 50, padding: '13px 28px', fontWeight: 700, display: 'inline-flex', alignItems: 'center', gap: 8 }}>
                                        <Search size={16} strokeWidth={2.5} /> Rechercher une annonce
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }

        return (
            <div className="list-page">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-12 col-md-7 col-lg-6">
                            <div className="list-page__header">
                                <h1 className="list-page__title">Messages</h1>
                            </div>
                            <div className="conversations-list">
                                {conversations.map(item => {
                                    const dep    = (item.announcement.departure  || '').split('--');
                                    const dest   = (item.announcement.destination || '').split('--');
                                    const unread = getUnread(item.user.id, item.announcement.id);
                                    const dateStr = new Intl.DateTimeFormat('fr-FR', { day: '2-digit', month: 'short' })
                                        .format(item.announcement.dateDeparture);

                                    return (
                                        <Link
                                            key={`${item.announcement.id}-${item.user.id}`}
                                            to={{ pathname: `/messages/${item.announcement.id}${item.user.id}`, state: { from: window.location.pathname } }}
                                            className="conv-item"
                                            onClick={() => this.handleClick(item)}
                                        >
                                            <img className="conv-item__avatar" src="/assets/images/profil.svg" alt={item.user.firstName} />
                                            <div className="conv-item__body">
                                                <div className="conv-item__name">{item.user.firstName} {item.user.lastName}</div>
                                                <div className="conv-item__route">{dep[0] || '—'} → {dest[0] || '—'}</div>
                                            </div>
                                            <div className="conv-item__right">
                                                <span className="conv-item__date">{dateStr}</span>
                                                {unread ? <Badge color="danger" pill style={{ fontSize: '0.72rem' }}>{unread}</Badge> : null}
                                            </div>
                                        </Link>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Messages;
